<template>
  <!-- 选择用户  -->
  <div class="h-select-user-view">
    <div class="tree-view--title" v-if="title">{{title}}</div>
    <div class="screen-box">
      <!-- 部门选择器 -->
      <el-cascader class="screen-box__item" :props="deptProps" ref="deptSelect" v-model="currentDept" @change="handleDeptChange" placeholder="请选择部门" :clearable="true" :show-all-levels="false"></el-cascader>
      <!-- 关键字选择器 -->
      <div class="screen-box__item keywords-screen">
        <el-input class="screen-box__item__input " v-model="keywords" placeholder="请输入用户名" clearable></el-input>
        <el-button type="primary" class="keywords-screen__btn" @click="keywordsSearch">
          <i class="el-icon-search"></i>
        </el-button>
      </div>

    </div>
    <div class="user-list">
      <el-tree :ref="treeRef" class="user-tree" :data="userList" :highlight-current="true" :props="userTreeProps" node-key="id" :current-node-key="currentNodeKey" default-expand-all :expand-on-click-node="false" @node-click="handleNodeClick"></el-tree>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
  data () {
    return {
      treeRef: 'hSelectUser' + this._uid,
      deptProps: {
        checkStrictly: true,
        emitPath: false,
        lazy: true,
        lazyLoad: this.deptLazyLoad
      },
      userTreeProps: { label: 'name' },
      keywords: '',//筛选关键字
      deptlist: [],//部门列表
      currentDept: null,//筛选当前选中部门
      userList: [],//用户列表
      currentUser: null//当前选中用户
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    }
    // value: {
    //   type: String,
    //   default: '选择用户'
    // },
  },
  created () {

  },
  mounted () {
    this.getUserList()
    this.getAtPresentUserDepInfo()
  },
  computed: {
    currentNodeKey: function () {
      return this.currentUser ? this.currentUser.id || '' : ''
    }
  },
  watch: {
    currentUser (val) {
      console.log('监听选中用户变化', val);
      this.$emit('change', val)
    },
    currentDept (val) {
      console.log('监听--------', val);
      this.getUserList()
    }
  },

  methods: {
    //获取当前用户所在部门信息
    getAtPresentUserDepInfo () {

    },
    //懒加载部门级联选择器
    deptLazyLoad (node, resolve) {
      if (node.data) {
        var params = { superId: node.data.value }

        this.$API.getDepartmentList(params).then(
          res => {
            if (Array.isArray(res)) {
              const nodes = res.map(item => ({
                value: item.id,
                label: item.deptName
              }))
              // 通过调用resolve将子节点数据返回，通知组件数据加载完成
              resolve(nodes)
            }
          },
          err => {
            console.log('获取部门列表', err)
          }
        )
      } else {
        let deptId = this.$store.state.system.userInfo.departmentId
        if (!deptId) {
          return
        }
        let data = {};
        data.dept_id = deptId
        this.$API.getDepartmentDetail(data).then(
          res => {
            const nodes = [{
              value: res.id,
              label: res.deptName
            }]
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes)

          },
          err => {
          }
        )
      }

    },
    // 部门选择器选中状态变化
    handleDeptChange (e) {
      this.currentDept = e
      this.$refs.deptSelect.dropDownVisible = false

    },
    // 获取用户列表
    getUserList () {
      let data = {}
      if (this.currentDept) {
        data.deptId = this.currentDept
      }
      if (this.keywords) {
        data.emplpyeeNmae = this.keywords
      }
      this.$API.getEmployeeList(data).then(
        res => {
          console.log('##############查询用户list', res);
          this.userList = res
          if (res.length > 0) {
            this.currentUser = res[0]
            this.$nextTick(() => {
              this.$refs[this.treeRef].setCurrentKey(res[0].id)
            })
          }
        },
        err => {

        }
      )
    },
    // 关键字搜索
    keywordsSearch () {
      this.getUserList()
    },
    // 选择用户
    handleNodeClick (e) {
      this.currentUser = e
    }

  },
}
</script>
<style scoped lang="stylus">
.h-select-user-view
  height inherit
  width inherit
  display flex
  flex-direction column
  .title, .screen-box
    display flex
    flex-direction row
    flex-wrap wrap
    width 100%
    // min-height 160px
    .screen-box__item
      width 100%
      margin-bottom 20px
      display flex
      flex-direction row
      .screen-box__item__input
        width 100%
    .keywords-screen
      display flex
      >>> .el-input__inner
        border-radius 4px 0px 0px 4px
      .keywords-screen__btn
        background #3B5EFF
        width 40px
        height 40px
        border-radius 0 4px 4px 0
        line-height 40px
        padding 0
  .user-list
    flex 1
    overflow-y auto
</style>



// WEBPACK FOOTER //
// src/components/parts/hSelectUserView.vue